import { appState, setValidLanguageToAppState } from './state.js';

// Debugging confirmation
console.log('✅ build-manager-pages.js loaded successfully!');

// Cache dynamic imports of page builder modules
const _pageBuilderImportCache = {};

async function loadPageBuilder(pageKey, params = [], valuesInUrl = []) {
  console.log(`🔄 Loading page builder for: ${pageKey}`);

  if (!_pageBuilderImportCache[pageKey]) {
    let importedModule;

    switch (pageKey) {
      case 'keyHome':
        importedModule = await import(
          /* webpackChunkName: "page-builder-home" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-home.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentHomePage;
        break;

      //* ------------- Blog Pages ------------- */
      case 'keyBlog':
        importedModule = await import(
          /* webpackChunkName: "page-builder-blog-home" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-blog-home.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentBlogHomePage;
        break;

      case 'keyBlogArticle':
        importedModule = await import(
          /* webpackChunkName: "page-builder-blog-article" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-blog-article.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentBlogArticlePage;
        break;

      case 'keyBlogCategory':
        importedModule = await import(
          /* webpackChunkName: "page-builder-blog-category" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-blog-category.js'
        );
            _pageBuilderImportCache[pageKey] = importedModule.buildContentBlogCategoryPage;
        break;

      case 'keyBlogCategories':
        importedModule = await import(
          /* webpackChunkName: "page-builder-blog-categories" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-blog-categories.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentBlogCategoriesPage;
        break;

      //* ------------- End Blog Pages ------------- */

      //* ------------- Catalog Pages ------------- */

      case 'keyCategory':
        importedModule = await import(
          /* webpackChunkName: "page-builder-category" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-category.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentCategoryPage;
        break;

      case 'keyCategories':
        importedModule = await import(
          /* webpackChunkName: "page-builder-categories" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-categories.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentCategoriesPage;
        break;

      case 'keySubcategory':
        importedModule = await import(
          /* webpackChunkName: "page-builder-subcategory" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-subcategory.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentSubcategoryPage;
        break;

      case 'keySubcategories':
        importedModule = await import(
          /* webpackChunkName: "page-builder-subcategories" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-subcategories.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentSubcategoriesPage;
        break;

      case 'keyProducts':
        importedModule = await import(
          /* webpackChunkName: "page-builder-products" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-products.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentProductsPage;
        break;

      case 'keyProduct':
        importedModule = await import(
          /* webpackChunkName: "page-builder-product" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-product.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentProductPage;
        break;

      case 'keySearch':
        importedModule = await import(
          /* webpackChunkName: "page-builder-search" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-search.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentSearchPage;
        break;

      case 'keyListing':
        importedModule = await import(
          /* webpackChunkName: "page-builder-listing" */
          /* webpackPrefetch: true */
          '../builders-pages/page-builder-listing.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentListingPage;
        break;

      //* ------------- End catalog Pages ------------- */

      //* ------------- Auth Pages ------------- */
      case 'keyRegister':
        importedModule = await import(
          /* webpackChunkName: "page-builder-register" */
          /* webpackPrefetch: true */
          '../builders-pages/auth/page-builder-register.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentRegister;
        break;

      case 'keySignIn':
      case 'keyLogin':
        importedModule = await import(
          /* webpackChunkName: "page-builder-sign-in" */

          '../builders-pages/auth/page-builder-sign-in.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentSignIn;
        break;

      case 'keyForgotPassword':
        importedModule = await import(
          /* webpackChunkName: "page-builder-forgot-password" */

          '../builders-pages/auth/page-builder-forgot-password.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentForgotPassword;
        break;

      case 'keyResetPassword':
        importedModule = await import(
          /* webpackChunkName: "page-builder-reset-password" */

          '../builders-pages/auth/page-builder-reset-password.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentResetPassword;
            break;

        case 'keyRegistrationComplete':
            importedModule = await import(
        /* webpackChunkName: "page-builder-registration-complete" */
                '../builders-pages/auth/page-builder-registration-complete.js'
            );
            _pageBuilderImportCache[pageKey] = importedModule.buildContentRegistrationComplete;
            break;

        case 'keyConfirmRegistrationEmailResent':
            importedModule = await import(
                /* webpackChunkName: "page-builder-confirm-registration-email-resent" */
                '../builders-pages/auth/page-builder-confirm-registration-email-resent.js'
            );
            _pageBuilderImportCache[pageKey] = importedModule.buildContentConfirmRegistrationEmailResent;
            break;

        case 'keyConfirmAccount':
            importedModule = await import(
                /* webpackChunkName: "page-builder-confirm-account" */
                '../builders-pages/auth/page-builder-confirm-account.js'
            );
            _pageBuilderImportCache[pageKey] = importedModule.buildContentConfirmAccount;
            break;

      case 'keyLogout':
        importedModule = await import(
          /* webpackChunkName: "page-builder-logout" */

          '../builders-pages/auth/page-builder-logout.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentLogout;
        break;

      //* ------------- End Auth Pages ------------- */

      //* ------------- Checkout Pages ------------- */
      case 'keyShoppingCart':
        importedModule = await import(
          /* webpackChunkName: "page-builder-shopping-cart" */

          '../builders-pages/page-builder-shopping-cart.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentShoppingCartPage;
        break;

      //* ------------- End Checkout Pages ------------- */

      //* ------------- Account Pages Personal ------------- */

      case 'keySelectProfile':
        importedModule = await import(
          /* webpackChunkName: "page-builder-select-profile" */
          '../builders-pages/account/page-builder-select-profile.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentSelectProfile;
        break;

      case 'keyDashboard':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-home" */
          '../builders-pages/account/personal/page-builder-account-personal-home.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalHome;
        break;

      case 'keyMyMail':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-mail" */
          '../builders-pages/account/personal/page-builder-account-personal-mail.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalMail;
        break;

      case 'keyMyChats':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-chats" */
          '../builders-pages/account/personal/page-builder-account-personal-chats.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalChats;
        break;

      case 'keyMyOrders':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-orders-list" */
          '../builders-pages/account/personal/page-builder-account-personal-orders-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalOrdersList;
        break;

      case 'keyMyOrder':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-order-details" */
          '../builders-pages/account/personal/page-builder-account-personal-order-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalOrderDetails;
        break;

      case 'keyMyReturns':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-returns-list" */
          '../builders-pages/account/personal/page-builder-account-personal-returns-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalReturnsList;
        break;

      case 'keyMyReturn':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-return-details" */
          '../builders-pages/account/personal/page-builder-account-personal-return-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalReturnDetails;
        break;

      case 'keyMyReturnRequest':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-return-create" */
          '../builders-pages/account/personal/page-builder-account-personal-return-create.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalReturnCreate;
        break;

      case 'keyMyQuotes':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-quotes-list" */
          '../builders-pages/account/personal/page-builder-account-personal-quotes-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalQuotesList;
        break;

      case 'keyMyQuote':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-quote-details" */
          '../builders-pages/account/personal/page-builder-account-personal-quote-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalQuoteDetails;
        break;

      case 'keyMyQuoteCreate':
      case 'keyCreateQuoteRequest':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-quote-create" */
          '../builders-pages/account/personal/page-builder-account-personal-quote-create.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalQuoteCreate;
        break;

      case 'keyMyWishlist':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-wishlist" */
          '../builders-pages/account/personal/page-builder-account-personal-wishlist.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalWishlist;
        break;

      case 'keyMyPreviousPurchases':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-previous-purchases" */
          '../builders-pages/account/personal/page-builder-account-personal-previous-purchases.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountPersonalPreviousPurchases;
        break;

      case 'keyMyProductReviews':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-product-reviews-list" */
          '../builders-pages/account/personal/page-builder-account-personal-product-reviews-list.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountPersonalProductReviewsList;
        break;

      case 'keyMyProductReview':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-product-review-details" */
          '../builders-pages/account/personal/page-builder-account-personal-product-review-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountPersonalProductReviewDetails;
        break;

      case 'keyMyRecentlyViewedProducts':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-recently-viewed-products" */
          '../builders-pages/account/personal/page-builder-account-personal-recently-viewed-products.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountPersonalRecentlyViewedProducts;
        break;

      case 'keyMyDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-details" */
          '../builders-pages/account/personal/page-builder-account-personal-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalDetails;
        break;

      case 'keyMyPaymentMethods':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-payment-methods-list" */
          '../builders-pages/account/personal/page-builder-account-personal-payment-methods-list.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountPersonalPaymentMethodsList;
        break;

      case 'keyMyAddresses':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-my-addresses" */
          '../builders-pages/account/personal/page-builder-account-personal-addresses.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalAddresses;
        break;

      case 'keyMyAddress':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-my-address" */
          '../builders-pages/account/personal/page-builder-account-personal-address.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalAddress;
        break;

      case 'keyMyPaymentMethod':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-payment-method-details" */
          '../builders-pages/account/personal/page-builder-account-personal-payment-method-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountPersonalPaymentMethodDetails;
        break;

      case 'keyMyNewsletterSubscription':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-newsletter" */
          '../builders-pages/account/personal/page-builder-account-personal-settings-newsletter.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountPersonalSettingsNewsletter;
        break;

      case 'keyMySettings':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-personal-settings" */
          '../builders-pages/account/personal/page-builder-account-personal-settings.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountPersonalSettings;
        break;

      //* ------------- End Account Pages Persoanl ------------- */

      //* ------------- Account Pages Business ------------- */

      case 'keyBusinessDashboard':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-home" */
          '../builders-pages/account/business/page-builder-account-business-home.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessHome;
        break;

      case 'keyBusinessMail':
      case 'keyBusinessMessages':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-mail" */
          '../builders-pages/account/business/page-builder-account-business-mail.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessMail;
        break;

      case 'keyBusinessChats':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-chats" */
          '../builders-pages/account/business/page-builder-account-business-chats.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessChats;
        break;

      case 'keyBusinessOrders':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-orders-list" */
          '../builders-pages/account/business/page-builder-account-business-orders-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessOrdersList;
        break;

      case 'keyBusinessOrder':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-order-details" */
          '../builders-pages/account/business/page-builder-account-business-order-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessOrderDetails;
        break;

      case 'keyBusinessReturns':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-returns-list" */
          '../builders-pages/account/business/page-builder-account-business-returns-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessReturnsList;
        break;

      case 'keyBusinessReturn':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-return-details" */
          '../builders-pages/account/business/page-builder-account-business-return-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessReturnDetails;
        break;

      case 'keyBusinessReturnRequest':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-return-create" */
          '../builders-pages/account/business/page-builder-account-business-return-create.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessReturnCreate;
        break;

      case 'keyBusinessQuotes':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-quotes-list" */
          '../builders-pages/account/business/page-builder-account-business-quotes-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessQuotesList;
        break;

      case 'keyBusinessQuote':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-quote-details" */
          '../builders-pages/account/business/page-builder-account-business-quote-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessQuoteDetails;
        break;

      case 'keyBusinessQuoteCreate':
      case 'keyCreateBusinessQuoteRequest':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-quote-create" */
          '../builders-pages/account/business/page-builder-account-business-quote-create.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessQuoteCreate;
        break;

      case 'keyBusinessWishlist':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-wishlist" */
          '../builders-pages/account/business/page-builder-account-business-wishlist.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessWishlist;
        break;

      case 'keyBusinessPreviousPurchases':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-previous-purchases" */
          '../builders-pages/account/business/page-builder-account-business-previous-purchases.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessPreviousPurchases;
        break;

      case 'keyBusinessProductReviews':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-product-reviews-list" */
          '../builders-pages/account/business/page-builder-account-business-product-reviews-list.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessProductReviewsList;
        break;

      case 'keyBusinessProductReview':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-product-review-details" */
          '../builders-pages/account/business/page-builder-account-business-product-review-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessProductReviewDetails;
        break;

      case 'keyBusinessRecentlyViewedProducts':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-recently-viewed-products" */
          '../builders-pages/account/business/page-builder-account-business-recently-viewed-products.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessRecentlyViewedProducts;
        break;

      case 'keyBusinessDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-details" */
          '../builders-pages/account/business/page-builder-account-business-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessDetails;
        break;

      case 'keyBusinessPaymentMethods':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-payment-methods-list" */
          '../builders-pages/account/business/page-builder-account-business-payment-methods-list.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessPaymentMethodsList;
        break;

      case 'keyBusinessAddresses':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-my-addresses" */
          '../builders-pages/account/business/page-builder-account-business-addresses.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessAddresses;
        break;

      case 'keyBusinessAddress':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-my-address" */
          '../builders-pages/account/business/page-builder-account-business-address.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessAddress;
        break;

      case 'keyBusinessPaymentMethod':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-payment-method-details" */
          '../builders-pages/account/business/page-builder-account-business-payment-method-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessPaymentMethodDetails;
        break;

      case 'keyBusinessNewsletterSubscription':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-newsletter" */
          '../builders-pages/account/business/page-builder-account-business-settings-newsletter.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessSettingsNewsletter;
        break;

      case 'keyBusinessSettings':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-settings" */
          '../builders-pages/account/business/page-builder-account-business-settings.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessSettings;
        break;

      //* ------------- Not Shared Business pages ------------- */

      //tbc

      //* -------------  Shared With Store ------------- */
      case 'keyBusinessCompleteVerification':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-complete-verification" */
          '../builders-pages/account/business/page-builder-account-business-complete-verification.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessCompleteVerification;
        break;

      case 'keyMyRegisteredCompany':
      case 'keyBusinessRegisteredCompanyDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-registered-company-details" */
          '../builders-pages/account/business/page-builder-account-business-registered-company-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessRegisteredCompanyDetails;
        break;

      case 'keyBusinessMyCompaniesList':
      case 'keyMyCompanies':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-my-companies-list" */
          '../builders-pages/account/business/page-builder-account-business-my-companies-list.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessMyCompaniesList;
        break;

        case 'keyBusinessMyCompanyDetails':
        case 'keyMyCompanyDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-my-company-details" */
          '../builders-pages/account/business/page-builder-account-business-my-company-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessMyCompanyDetails;
        break;

      case 'keyBusinessTradingAddressesList':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-trading-addresses-list" */
          '../builders-pages/account/business/page-builder-account-business-trading-addresses-list.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessTradingAddressesList;
        break;

      case 'keyBusinessTradingAddressDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-trading-address-details" */
          '../builders-pages/account/business/page-builder-account-business-trading-address-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessTradingAddressDetails;
        break;

      case 'keyBusinessUsersList':
      case 'keyBusinessUsers':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-users-list" */
          '../builders-pages/account/business/page-builder-account-business-users-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessUsersList;
        break;

      case 'keyBusinessUserDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-user-details" */
          '../builders-pages/account/business/page-builder-account-business-user-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessUserDetails;
        break;

      case 'keyBusinessUserRolesList':
      case 'keyBusinessRoles':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-user-roles-list" */
          '../builders-pages/account/business/page-builder-account-business-user-roles-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessUserRolesList;
        break;

      case 'keyBusinessUserRoleDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-user-role-details" */
          '../builders-pages/account/business/page-builder-account-business-user-role-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountBusinessUserRoleDetails;
        break;

      case 'keyBusinessUsersInRole':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-business-users-in-role" */
          '../builders-pages/account/business/page-builder-account-business-users-in-role.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountBusinessUsersInRole;
        break;

      //* ------------- End Shared With Store ------------- */

      //* ------------- End Account Pages Business ------------- */

      //* -------------  Seller  Pages ------------- */

      case 'keyMyStore':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-home" */
          '../builders-pages/account/store/page-builder-account-store-home.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreHome;
        break;

      case 'keyPreviewStore':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-preview-store" */
          '../builders-pages/account/store/page-builder-account-store-preview-store.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStorePreviewStore;
        break;

      case 'keyStoreMail':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-mail" */
          '../builders-pages/account/store/page-builder-account-store-mail.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreMail;
        break;

      case 'keyStoreChats':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-chats" */
          '../builders-pages/account/store/page-builder-account-store-chats.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreChats;
        break;

      case 'keyStoreProducts':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-products-list" */
          '../builders-pages/account/store/page-builder-account-store-products-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreProductsList;
        break;

      case 'keyStoreProduct':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-product-details" */
          '../builders-pages/account/store/page-builder-account-store-product-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreProductDetails;
        break;

      case 'keyStoreProductCreate':
      case 'keyCreateProduct':
      case 'keyCreateNewProduct':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-product-create" */
          '../builders-pages/account/store/page-builder-account-store-product-create.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreProductCreate;
        break;

      case 'keyStoreSalesReport':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-sales-report" */
          '../builders-pages/account/store/page-builder-account-store-sales-report.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreSalesReport;
        break;

      case 'keyStoreInventoryReport':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-inventory-report" */
          '../builders-pages/account/store/page-builder-account-store-inventory-report.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreInventoryReport;
        break;

      case 'keyStoreOrders':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-orders-list" */
          '../builders-pages/account/store/page-builder-account-store-orders-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreOrdersList;
        break;

      case 'keyStoreOrder':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-order-details" */
          '../builders-pages/account/store/page-builder-account-store-order-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreOrderDetails;
        break;

      case 'keyStoreReturns':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-returns-list" */
          '../builders-pages/account/store/page-builder-account-store-returns-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreReturnsList;
        break;

      case 'keyStoreReturn':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-return-details" */
          '../builders-pages/account/store/page-builder-account-store-return-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreReturnDetails;
        break;

      case 'keyStoreQuotes':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-quotes-list" */
          '../builders-pages/account/store/page-builder-account-store-quotes-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreQuotesList;
        break;

      case 'keyStoreQuote':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-quote-details" */
          '../builders-pages/account/store/page-builder-account-store-quote-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreQuoteDetails;
        break;

      case 'keyStoreQuoteCreate':
      case 'keyCreateStoreQuoteRequest':
      case 'keyCreateStoreQuote':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-quote-create" */
          '../builders-pages/account/store/page-builder-account-store-quote-create.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreQuoteCreate;
        break;

      case 'keyStoreExploreTenders':
      case 'keyExploreTenders':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-explore-tenders" */
          '../builders-pages/account/store/page-builder-account-store-explore-tenders.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreExploreTenders;
        break;

      case 'keyStoreSettingsShippingCharges':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-settings-shipping-charges" */
          '../builders-pages/account/store/page-builder-account-store-settings-shipping-charges.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountStoreSettingsShippingCharges;
        break;

      case 'keyStoreSettingsDefaultSellingCompany':
      case 'keyStoreSettingsSellingCompany':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-settings-default-selling-company" */
          '../builders-pages/account/store/page-builder-account-store-settings-default-selling-company.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountStoreSettingsDefaultSellingCompany;
        break;

      case 'keyStoreBankAccount':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-bank-account" */
          '../builders-pages/account/store/page-builder-account-store-bank-account.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreBankAccount;
        break;

      case 'keyStorePaymentMethods':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-payment-methods-list" */
          '../builders-pages/account/store/page-builder-account-store-payment-methods-list.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountStorePaymentMethodsList;
        break;

      case 'keyStorePaymentMethod':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-payment-method-details" */
          '../builders-pages/account/store/page-builder-account-store-payment-method-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountStorePaymentMethodDetails;
        break;

      //* -------------  Shared With Shared With Store ------------- */
      case 'keyStoreCompleteVerification':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-complete-verification" */
          '../builders-pages/account/store/page-builder-account-store-complete-verification.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountStoreCompleteVerification;
        break;

      case 'keyStoreRegisteredCompany':
      case 'keyStoreRegisteredCompanyDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-registered-company-details" */
          '../builders-pages/account/store/page-builder-account-store-registered-company-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountStoreRegisteredCompanyDetails;
        break;

      case 'keyStoreCompaniesList':
      case 'keyStoreCompanies':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-companies-list" */
          '../builders-pages/account/store/page-builder-account-store-companies-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreMyCompaniesList;
        break;

      case 'keyStoreCompanyDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-company-details" */
          '../builders-pages/account/store/page-builder-account-store-company-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreCompanyDetails;
        break;

      case 'keyStoreTradingAddressesList':
      case 'keyStoreTradingAddresses':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-trading-addresses-list" */
          '../builders-pages/account/store/page-builder-account-store-trading-addresses-list.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountStoreTradingAddressesList;
        break;

      case 'keyStoreTradingAddressDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-trading-address-details" */
          '../builders-pages/account/store/page-builder-account-store-trading-address-details.js'
        );
        _pageBuilderImportCache[pageKey] =
          importedModule.buildContentAccountStoreTradingAddressDetails;
        break;

      case 'keyStoreUsersList':
      case 'keyStoreUsers':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-users-list" */
          '../builders-pages/account/store/page-builder-account-store-users-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreUsersList;
        break;

      case 'keyStoreUserDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-user-details" */
          '../builders-pages/account/store/page-builder-account-store-user-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreUserDetails;
        break;

      case 'keyStoreUserRolesList':
      case 'keyStoreRoles':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-user-roles-list" */
          '../builders-pages/account/store/page-builder-account-store-user-roles-list.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreUserRolesList;
        break;

      case 'keyStoreUserRoleDetails':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-user-role-details" */
          '../builders-pages/account/store/page-builder-account-store-user-role-details.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreUserRoleDetails;
        break;

      case 'keyStoreUsersInRole':
        importedModule = await import(
          /* webpackChunkName: "page-builder-account-store-users-in-role" */
          '../builders-pages/account/store/page-builder-account-store-users-in-role.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccountStoreUsersInRole;
        break;

      //* ------------- End Shared With Business ------------- */

      //* ------------- End Store Pages  ------------- */

      //* ------------- Other Pages ------------- */

      case 'keyContactUs':
        importedModule = await import(
          /* webpackChunkName: "page-builder-contact-us" */

          '../builders-pages/page-builder-contact-us.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentContactUs;
        break;

      case 'keyAboutUs':
        importedModule = await import(
          /* webpackChunkName: "page-builder-about-us" */
          '../builders-pages/page-builder-about-us.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAboutUs;
        break;

      case 'keyCreateStore':
        importedModule = await import(
          /* webpackChunkName: "page-builder-create-store" */
          '../builders-pages/page-builder-create-store.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentCreateStore;
        break;

      case 'keyCreateBusinessAccount':
        importedModule = await import(
          /* webpackChunkName: "page-builder-create-business-account" */
          '../builders-pages/page-builder-create-business-account.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentCreateBusinessAccount;
        break;

      case 'keyStore':
      case 'keySellerStore':
        importedModule = await import(
          /* webpackChunkName: "page-builder-store" */
          '../builders-pages/page-builder-store.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentStore;
        break;

      case 'key404':
        importedModule = await import(
          /* webpackChunkName: "page-builder-404" */
          '../builders-pages/page-builder-404.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContent404;
        break;

      case 'keySell':
      case 'keyBecomeASeller':
        importedModule = await import(
          /* webpackChunkName: "page-builder-become-a-seller" */
          '../builders-pages/page-builder-become-a-seller.js'
        );

        _pageBuilderImportCache[pageKey] = importedModule.buildContentBecomeASeller;
        break;

      case 'keyPaymentProtection':
        importedModule = await import(
          /* webpackChunkName: "page-builder-payment-protection" */
          '../builders-pages/page-builder-payment-protection.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentPaymentProtection;
        break;

      case 'keySiteMap':
        importedModule = await import(
          /* webpackChunkName: "page-builder-site-map" */
          '../builders-pages/page-builder-site-map.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentSiteMap;
        break;

      case 'keyFAQs':
        importedModule = await import(
          /* webpackChunkName: "page-builder-faqs" */
          '../builders-pages/page-builder-faqs.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentFAQs;
        break;

      case 'keyTermsAndConditions':
        importedModule = await import(
          /* webpackChunkName: "page-builder-terms-and-conditions" */
          '../builders-pages/policies/page-builder-terms-and-conditions.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentTermsAndConditions;
        break;

      case 'keyPrivacyPolicy':
      case 'keySecurityNPrivacyPolicy':
        importedModule = await import(
          /* webpackChunkName: "page-builder-privacy-policy" */
          '../builders-pages/policies/page-builder-privacy-policy.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentPrivacyPolicy;
        break;

      case 'keyCookiesPolicy':
        importedModule = await import(
          /* webpackChunkName: "page-builder-cookies-policy" */
          '../builders-pages/policies/page-builder-cookies-policy.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentCookiesPolicy;
        break;

      case 'keyCookiePreferences':
        importedModule = await import(
          /* webpackChunkName: "page-builder-cookie-preferences" */
          '../builders-pages/policies/page-builder-cookie-preferences.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentCookiePreferences;
        break;

      case 'keyAccessibilityStatement':
        importedModule = await import(
          /* webpackChunkName: "page-builder-accessibility-statement" */
          '../builders-pages/policies/page-builder-accessibility-statement.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentAccessibilityStatement;
        break;

      // Example fallback/default
      default:
        importedModule = await import(
          /* webpackChunkName: "page-content-general-static" */
          /* webpackPrefetch: true */
          '../builders-pages/page-content-builder-general-always-static-page.js'
        );
        _pageBuilderImportCache[pageKey] = importedModule.buildContentGeneralAlwaysStaticBuilder;
    }
  }

  return _pageBuilderImportCache[pageKey](params, valuesInUrl);
}

export async function buildContentForPageByPageBuilderContentManager(pageKey, params, valuesInUrl) {
  // return "helooe world 2";
  console.log(
    `🔄 Building content for page: ${pageKey}, params: ${params}, valuesInUrl: ${valuesInUrl}`
  );

  try {
    const {
      masterPageName,
      masterPageHtml,
      pageContentHtml,
      pageHeaderTags,
    } = await loadPageBuilder(pageKey, params, valuesInUrl);

    return {
      masterPageName: masterPageName,
      masterPageHtml: masterPageHtml,
      pageContentHtml: pageContentHtml,
      pageHeaderTags: pageHeaderTags,
    };
  } catch (error) {
    console.error('❌ Error building content:', error);
    return 'Error loading page content.';
  }
}

export async function buildContentForPageByPageBuilderContentManagerWEBPACKNode(
  pageKey,
  params,
  valuesInUrl
) {
  // return "helooe world 2";
  console.log(
    `🔄 Building content for page WEBPACK NODE: ${pageKey}, params: ${params}, valuesInUrl: ${valuesInUrl}`
  );

  try {
    //return `🔄 Building content for page WEBPACK NODE: ${pageKey}, params: ${params}, valuesInUrl: ${valuesInUrl}`;

    const {
      masterPageName,
      masterPageHtml,
      pageContentHtml,
      pageHeaderTags,
    } = await loadPageBuilder(pageKey, params, valuesInUrl);

    const finalPageResult = masterPageHtml.replace('{{{ content }}}', pageContentHtml);

    //pageHeaderTags = "<title" > + " testing 2" + "</title>";

    return {
      pageBodyHTML: finalPageResult,
      pageHeaderHTML: pageHeaderTags,
    };

    //let masterPageHtmlContent = masterPageHtml;
    //let pageContentHtmlContent = pageContentHtml;

    //if (!masterPageHtmlContent) {
    //    console.error("❌ No master page HTML content found.");
    //    return "Error loading master page content.";
    //}

    //if (!pageContentHtmlContent) {
    //    console.error("❌ No page content HTML found.");
    //    return "Error loading page content.";
    //}
    //// Replace the {{{ content }}} placeholder in the master page HTML with the actual page content

    //let result = masterPageHtmlContent.replace("{{{ content }}}", pageContentHtmlContent);

    return finalPageResult;
  } catch (error) {
    console.error('❌ Error building content WEBPACK NODE:', error);
    return 'Error loading page content WEBPACK NODE.';
  }
}
